export const modalTimeout = 3000;
export const modalTimeoutErro = 5000;

export const tipoAcesso = {
  ADM: "empresa",
  DIR: "empresa",
  GER: "empresa",
  COR: "empresa",
  ANA: "empresa",
};